import React from 'react'

function SvgDocumentIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      fill="none"
      viewBox="0 0 21 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M12.167 1.891v3.442c0 .467 0 .7.091.879.08.156.208.284.364.364.179.09.412.09.879.09h3.442m-3.109 4.167H7.167m6.667 3.334H7.167M8.834 7.5H7.167m5-5.833H7.834c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 00-1.093 1.093c-.272.534-.272 1.234-.272 2.635v8.666c0 1.4 0 2.1.272 2.635A2.5 2.5 0 005.2 18.061c.535.272 1.235.272 2.635.272h5.333c1.4 0 2.1 0 2.635-.272a2.5 2.5 0 001.093-1.093c.272-.535.272-1.235.272-2.635V6.667l-5-5z"
      ></path>
    </svg>
  )
}

export default SvgDocumentIcon
